
export * from './toast';

import { ToastComponent } from './toast'

export const NotificationOrganisms = [
    ToastComponent
]